import { render, staticRenderFns } from "./TheAzureBillingPeriodList.vue?vue&type=template&id=97ebf19a&"
import script from "./TheAzureBillingPeriodList.vue?vue&type=script&lang=js&"
export * from "./TheAzureBillingPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports